import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Body} from 'shells/typography/body';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNoun} from '../../helpers';

type Props = {
    serviceType: ExternalServiceType;
};

export function CalendarSyncCta(props: Props) {
    return (
        <OnboardingBody title='Sync your calendar'>
            <div className='my-16'>
                <Body>
                    Nutshell and {getServiceNoun(props.serviceType)} work better together when you
                    sync your calendar.
                </Body>
            </div>
        </OnboardingBody>
    );
}
